import { useMutation } from '@tanstack/react-query'

import { invitationsApi } from '../../api/invitations-api'

export function useAcceptPendingInvitations() {
  return useMutation({
    mutationFn: () => invitationsApi.acceptPendingInvitations(),
  })
}
